import React, { useState, useEffect } from 'react';
import EmailTemplateEditor from './components/EmailTemplateEditor';
import TemplateCategoryList from './components/TemplateCategoryList';
import Alert from '../../components/Alert/Alert';
import { getEmailTemplates, saveEmailTemplate } from './api/templateApi';

const EmailTemplate = () => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    loadTemplates();
  }, []);

  const showAlert = (type, message) => {
    setAlert({ type, message });
    setTimeout(() => setAlert(null), 5000); // Auto hide after 5 seconds
  };

  const handleError = (message) => {
    showAlert('warning', message);
  };

  const loadTemplates = async () => {
    setIsLoading(true);
    try {
      const response = await getEmailTemplates();
      setTemplates(response);
    } catch (error) {
      console.error('Error loading templates:', error);
      setTemplates([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTemplateSelect = (template) => {
    console.log('=== DEBUG: Main Component Template Select ===');
    console.log('Template received:', template);
    console.log('Template.templateId:', template.templateId);
    console.log('Template.id:', template.id);
    console.log('Template.name:', template.name);
    console.log('Template.type:', template.type);
    console.log('Template.isNew:', template.isNew);
    setSelectedTemplate(template);
    console.log('=== END DEBUG ===');
  };

  const handleSaveTemplate = async (templateData) => {
    console.log('=== DEBUG: Main Component Save Template ===');
    console.log('Template data received:', templateData);
    console.log('templateData.templateId:', templateData.templateId);
    try {
      await saveEmailTemplate(templateData);
      await loadTemplates();
      console.log('Template saved successfully');
      showAlert('success', 'Email template saved successfully!');
    } catch (error) {
      console.error('Error saving template:', error);
      showAlert('danger', 'Failed to save email template. Please try again.');
    }
    console.log('=== END DEBUG ===');
  };

  return (
    <div className="container-xl">
      {/* Alert Component */}
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
      <div className="row g-2 align-items-center">
        <div className="col">
          <h3 className="page-title m-0">Email Templates</h3>
        </div>
      </div>

      <div className="page-body">
        <div className="container-xl">
          <div className="row">
            {/* Left Sidebar - Template Categories */}
            <div className="col-md-4">
              <TemplateCategoryList
                templates={templates}
                selectedTemplate={selectedTemplate}
                onTemplateSelect={handleTemplateSelect}
                isLoading={isLoading}
              />
            </div>

            {/* Right Side - Email Editor */}
            <div className="col-md-8">
              <EmailTemplateEditor
                selectedTemplate={selectedTemplate}
                onSaveTemplate={handleSaveTemplate}
                onError={handleError}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplate; 